import dayjs from 'dayjs';

export const statusMapping = {
  notOpenYet: '尚未開放報名',
  expired: '報名已截止',
  full: '已額滿',
  available: '報名中',
  registered: '已報名此活動',
};

export const applyStatusType = (data) => {
  if (data.registered) {
    return 'registered';
  }

  if (dayjs().isBefore(dayjs(data.apply_start_date))) {
    return 'notOpenYet';
  }

  if (dayjs(dayjs()).isAfter(dayjs(data.apply_end_date), 'day')) {
    return 'expired';
  }

  return data.apply_limit <= data.apply_count ? 'full' : 'available';
};
